import { render, staticRenderFns } from "./randomBubbleClock.vue?vue&type=template&id=1871b24a&scoped=true"
import script from "./randomBubbleClock.vue?vue&type=script&lang=js"
export * from "./randomBubbleClock.vue?vue&type=script&lang=js"
import style0 from "./randomBubbleClock.vue?vue&type=style&index=0&id=1871b24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871b24a",
  null
  
)

export default component.exports